var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseButton',{staticClass:"flex items-center",attrs:{"tag":"RouterLink","primary":"","small":"","to":_vm.funnelViewRoute}},[_c('span',[_vm._v("View")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }